import yup from '../../../../config/yup';

export const deleteFileFromS3TaskValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('fileOperation'),
  function: yup.string().default('deleteFileFromS3'),
  parameters: yup.object().shape({
    targetS3Bucket: yup.string(),
    fileKey: yup.string(),
    deleteBucket: yup.boolean(),
    awsAccessKeyId: yup.string(),
    awsSecretAccessKey: yup.string(),
    awsRegion: yup.string(),
  }),
});
